import React from "react";
import { DialogContent, DialogActions } from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import Button from "../../../component-lib/Molecules/button/Button";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "16px 24px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    borderRadius: "8px",
    height: "auto",
    width: "600px",
    maxWidth: "none",
  },
}));

interface DeleteFacilityConfirmationDialogProps {
  isOpen: boolean;
  dialogHeading?: string;
  handleClose: (action: "cancel" | "delete") => void;
  facilityName?: string;
  relatedData?: any;
  warning?: string;
  message?: string;
}

const DeleteFacilityConfirmationDialog = ({
  isOpen = false,
  handleClose,
  dialogHeading = "Delete Facility",
  facilityName = "",
  relatedData = null,
  warning = "",
  message = "",
}: DeleteFacilityConfirmationDialogProps) => {
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose("cancel");
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center rounded-lg"
          style={{ margin: "14px 24px" }}
        >
          <Heading title={dialogHeading} />
          <div onClick={() => handleClose("cancel")} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent dividers>
          <div style={{ padding: "16px 0" }}>
            {/* {message && (
              <p style={{ marginBottom: "16px", color: "#393939" }}>{message}</p>
            )} */}

            {facilityName && (
              <p style={{ marginBottom: "16px", fontWeight: 600, color: "#393939" }}>
                Facility: {facilityName}
              </p>
            )}

            {relatedData && Object.keys(relatedData).length > 0 && (
              <div style={{ marginBottom: "16px" }}>
                <p style={{ marginBottom: "12px", fontWeight: 600, color: "#393939" }}>
                  Related Data:
                </p>
                <div
                  style={{
                    border: "1px solid #E8E8E8",
                    borderRadius: "4px",
                    padding: "16px",
                    backgroundColor: "#FAFAFA",
                  }}
                >
                  {Object.entries(relatedData).map(([key, value]: [string, any]) => {
                    if (key === "totalRelatedRecords") return null;
                    if (typeof value === "object" && value !== null && value.count !== undefined) {
                      return (
                        <div
                          key={key}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "8px 0",
                            borderBottom: "1px solid #E8E8E8",
                          }}
                        >
                          <span style={{ color: "#565656" }}>
                            {value.description || key}:
                          </span>
                          <span style={{ fontWeight: 600, color: "#393939" }}>
                            {value.count}
                          </span>
                        </div>
                      );
                    }
                    return null;
                  })}
                  {relatedData.totalRelatedRecords !== undefined && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "8px 0",
                        marginTop: "8px",
                        borderTop: "2px solid #D2D2D2",
                        fontWeight: 600,
                      }}
                    >
                      <span style={{ color: "#393939" }}>Total Related Records:</span>
                      <span style={{ color: "#b10909", fontWeight: 700 }}>
                        {relatedData.totalRelatedRecords}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {warning && (
              <p
                style={{
                  marginTop: "16px",
                  color: "#b10909",
                  fontWeight: 500,
                  fontSize: "14px",
                }}
              >
                {warning}
              </p>
            )}
          </div>
        </DialogContent>
        <DialogActions sx={{ pb: "20px", pr: "20px" }}>
          <Button
            label="Cancel"
            variant="outlined"
            onClickCb={() => handleClose("cancel")}
            style={{
              padding: "8px 24px",
              fontSize: "16px",
              marginRight: "12px",
            }}
          />
          <Button
            label="Delete"
            variant="contained"
            onClickCb={() => handleClose("delete")}
            style={{
              padding: "8px 24px",
              fontSize: "16px",
              background: "#b10909",
              border: "1px solid #b10909",
            }}
          />
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default DeleteFacilityConfirmationDialog;

